import React, {useEffect} from 'react'
import "react-step-progress-bar/styles.css";

import Page from '../Page'
import LoadingBanner from '../../components/LoadingBanner'
import BiddingTalentStep from './BiddingTalentStep'
import BiddingCandidatesStep from './BiddingCandidatesStep'
import BiddingProposalsStep from './BiddingProposalsStep'
import BiddingContractStep from './BiddingContractStep'
import Project from '../../models/Project'
import ErrorBanner from "../../components/ErrorBanner";
import BiddingBriefStep from "./BiddingBriefStep";
import BiddingNavbar from "./components/BiddingNavbar";
import Auth from "../../Auth";
import {ProjectContext, useProject} from "../../providers/ClientProjectProvider";
import {generatePath, Navigate, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {CancelProjectWrapper} from "../projects/CancelProjectModal";

class BiddingWizard extends Page {

    // static providerType = ClientProjectProvider;
    static contextType = ProjectContext;

    static strict = false;
    static path = '/client/project/bidding/:projectId';

    static AuthRequests = () => {
        return []
    }

    static pathFor(projectId, stepSlug) {
        if (TB.isObject(projectId)) {
            projectId = projectId.id;
        }

        return `${generatePath(
            this.path, {
                projectId: projectId,
            }
        )}/${stepSlug}`;
    }

    static defaultPath(project) {
        return this.pathFor(
            project,
            BiddingTalentStep.slug
        );
    }

    static steps(project) {
        if (!TB.isObject(project)) {
            return [];
        }

        const auth = TB.auth()?.user();

        let currentProject = Project.make({...project});
        // if (!TB.isObject(project)
        // 	|| !TB.isFunction(project.isService))
        // {
        // 	return [
        // 		BiddingTalentStep,
        // 		BiddingCandidatesStep,
        // 		// BiddingProposalsStep,
        // 		BiddingContractStep,
        // 	];
        // }
        if (currentProject?.isCancelled() || currentProject?.isActive()) {
            return [];
        }
        if (currentProject.isBYO()) {
            return [

                BiddingBriefStep,
                BiddingTalentStep,
                BiddingCandidatesStep,
                // BiddingProposalsStep,
                BiddingContractStep,
            ];
        }

        if (currentProject.isService()) {

            let steps = [
                BiddingBriefStep
            ];

            return [
                ...steps,
                BiddingTalentStep,
                BiddingProposalsStep,
                BiddingContractStep,
            ];
        }

        return [];
    }

    static stepWithSlug(slug, project) {
        let steps = this.steps(project);

        let lookup = TB.keyBy([...steps], 'slug');

        return lookup[slug];
    }


    constructor(props, context) {
        super(props, context);

        this.routeRef = React.createRef();
        this.state = {
            ...this.state,
            // projectId: this.props.projectId,
            // stepSlug: this.props.step,
            project: null,
            isLoading: false,
            error: null,
        };
    }

    trans(componentKey, replace = {}) {
        return TB.trans(
            `start_project.talent.${componentKey}`, replace
        );
    }

    componentDidMount() {
        super.componentDidMount();

        // this.fetchProject();
    }

    toggleUsability(enabled) {
        this.promisedState({
            isDisabled: !enabled,
        });
    }

    /*
    |--------------------------------------------------------------------------
    | Fetching Project from Cache or Server
    |--------------------------------------------------------------------------
    */

    // static handle = {
    //     'Projects@updated': (component, project) => {
    //         if (!component.state.isLoading && !component.state.project) {
    //             component.fetchProject()
    //         } else if (!component.state.isLoading) {
    //             component.updateProject(project);
    //         }
    //     },
    // };

    /*
    |--------------------------------------------------------------------------
    | Step Navigation
    |--------------------------------------------------------------------------
    */

    currentStep(project = this.context.project) {

        if (!project) {
            return;
        }

        return this.constructor.steps(project)[this.currentStepIndex(project)];
    }

    currentStepIndex(project = this.context.project) {
        return TB.findIndex(this.constructor.steps(project), (step, index) => {
            return this.props.location.pathname.indexOf(this.constructor.pathFor(this.props.projectId, step.slug)) > -1
        })
    }

    goToStep(step, search = undefined) {
        if (this.currentStep()) {
            if (search) {
                search += '&from=' + this.currentStep().slug;
            } else search = "?from=" + this.currentStep().slug
        }
        let path = this.constructor.pathFor(
            this.props.projectId,
            step.slug
        );
        if (step === BiddingTalentStep && this.context.project?.isService()) {
            path += '/teams'
        }
        this.props.navigate({
            pathname: path,
            search
        });
    }

    attemptNavigate(step) {
        return this.goToStep(step);
    }

    /*
    |--------------------------------------------------------------------------
    | Render Component
    |--------------------------------------------------------------------------
    */

    updateProject(project) {
        // console.log('BiddingWizard @ updateProject', { ...project });

        return this.context.update(project)
        // return this.promisedState({project});
    }

    render() {
        if (!this.props.location
            || !TB.auth().isAppropriate(this.props.location)) {
            return <Navigate to={Auth.appropriate()}/>
        }

        if (TB.isObject(this.context.error)) {
            return (
                <div className="flex items-center justify-center">
                    <ErrorBanner {...this.context.error} onRetry={this.context.refetch}/>
                </div>
            )
        }
        if (!this.context.project || this.context.isLoading) {
            return <LoadingBanner message={'projects.loading'} adjustOverlay/>;
        }

        // const CurrentStep = this.currentStep();

        let steps = this.constructor.steps(
            this.context.project
        );

        return (
            <div className="bidding-wizard">
                {!this.props.location.pathname.includes('profiles') && (
                    <BiddingNavbar
                        steps={steps}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        onStepNavigate={step => this.attemptNavigate(step)}
                    />
                )}

                <div className={TB.mapClass("bidding-wizard-step px-0", {
                    'bidding-wizard-disabled': this.state.isDisabled || this.context.isLoading || this.context.isDisabled
                })}>

                    <Outlet context={{
                        queryParams: this.props.queryParams,
                        toggleUsability: this.toggleUsability.bind(this),
                        isDisabled: this.state.isDisabled,
                        goToStep: this.goToStep.bind(this)
                    }}/>

                    <CancelProjectWrapper/>
                </div>
            </div>
        );
    }
}

const Wizard = (props) => {
    const {projectId} = useParams();
    const {project} = useProject();
    const {auth, appropriate} = useAuth()
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (project && auth && !auth?.canViewProjectBrief(project) &&
            !auth?.canViewSOWForProject(project) &&
            !auth?.canViewTalentForProject(project)) {
            TB.sysAlert('client.tab_visit_project_permission_error');
            return navigate(appropriate(), {replace: true})
        }
    }, [project, auth]);
    if (project && project?.isCancelled()) {
        // console.log('Wizardredirect!!!!!!!!!!!!!!')
        // TB.sysAlert('client.project_cancelled');
        return null;
    }
    return (
        <BiddingWizard projectId={projectId} navigate={navigate} location={location}/>
    )
}


export default Wizard;
export {
    BiddingWizard,
}

const styles = {
    navBar: {
        background: '#000000'
    },
    navBack: {
        color: '#F5F6F8',
        alignSelf: 'center',
    },
    navTitle: {
        color: '#F5F6F8',
        textAlign: 'center',
        fontSize: '21px',
        marginBottom: 5,
        marginTop: 15,
    },
    navEdit: {
        color: '#109CF1',
        marginLeft: '15px',
        fontSize: '12px',
    },
    navEstimates: {
        color: '#F5F6F8',
        alignSelf: 'center',
        textAlign: 'right',
        flex: 1,
    },
    navEstimateLabel: {
        fontSize: '10px',
        marginBottom: 3,
    },
    navEstimateRange: {
        fontSize: '17px',
        lineHeight: '17px',
        marginBottom: 1,
    },

    container: {
        flexDirection: 'column',
    },
};